import { useParams } from "react-router-dom";
import {
  useRequireCreateOrEditPermission,
  useRequirePermissionWhen,
} from "hooks/useRequirePermission";

/**
 * Centralizes route-level permission checks:
 * - `permissionId` — single permission (typical list routes; create-only flows like voucher add).
 * - `createPermissionId` + `editPermissionId` — create vs edit using `entityIdParam` from the URL (default `id`).
 * - `skipPermissionGate` — skip all checks (e.g. profile screens that intentionally omit permission checks).
 */
export default function PermissionRouteGate({
  permissionId,
  createPermissionId,
  editPermissionId,
  entityIdParam = "id",
  skipPermissionGate,
  children,
}) {
  const params = useParams();
  const entityId = params[entityIdParam];

  const listEnabled =
    permissionId != null && !skipPermissionGate;
  useRequirePermissionWhen(permissionId, listEnabled);

  const createEditEnabled =
    createPermissionId != null &&
    editPermissionId != null &&
    !skipPermissionGate;
  useRequireCreateOrEditPermission({
    id: entityId,
    createPermission: createPermissionId,
    editPermission: editPermissionId,
    enabled: createEditEnabled,
  });

  return children;
}
